import React, { useState, ChangeEvent, FormEvent } from 'react';
import { useNavigate } from 'react-router-dom';
import emailjs from '@emailjs/browser';
import './Contact.css';
import image64 from '../img/img-64.jpg';
import MapComponent from '../Map/Map';
import Header from '../Header/Header';
import Footer from '../Footer/Footer';

interface FormData {
  firstName: string;
  lastName: string;
  email: string;
  message: string;
}

const Contact: React.FC = () => {
  const navigateTo = useNavigate();
  const [formData, setFormData] = useState<FormData>({
    firstName: '',
    lastName: '',
    email: '',
    message: '',
  });

  const handleChange = (e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const sendEmail = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    emailjs.init("NOhjCeVRRloMXTyKp");

    emailjs.send("service_qd1vk69", "template_k23t2np", {
      to_name: 'Mrs. Cecily',
      from_name: formData.email,
      message: formData.message,
    })
      .then((response) => {
        alert('Email sent successfully!');
        console.log("Email sent:", response);
        setFormData({
          firstName: '',
          lastName: '',
          email: '',
          message: '',
        });
      })
      .catch((error) => {
        alert('Failed to send email. Please try again later.');
        console.error('Failed...', error);
      });
  };

  return (
    <div className='body'>
     <Header onSearchClick={() => console.log("Search button clicked")} />

      <div className="parent-container70">
        <div className="container70">
          <h1>Get in Touch</h1>
          <p>Reach out to us for any inquiries, feedback, or assistance regarding our services. We are here to help.</p>
        </div>
      </div>

      <div className="parent-container71">
        <div className="container71">
          <div className="img-62">
            <figure>
              <img src={image64} alt="img-62" />
            </figure>
          </div>

          <div className="patch13">
            <div className="info52">
              <h1>Contact Us for Assistance and Inquiries</h1>
            </div>

            <div className="phone">
              <h3>Phone</h3>
              <p>+44 07737024736</p>
              <div className="hr9"></div>
            </div>

            <div className="email">
              <h3>Email</h3>
              <p>paulfortuneltd@gmail.com</p>
              <div className="hr10"></div>
            </div>

            <div className="address">
              <h3>Address</h3>
              <p>1121/A, 5th G Block, Further Extension, BDA Layout, Anjanapura, Bangalore 560108.</p>
              <div className="hr11"></div>
            </div>
          </div>
        </div>
      </div>

      <div className='parent-container72'>
        <div className="form-container">
          <h1>Send Us a Message</h1>
          <p>Fill out the form below to reach our team. We will respond to your inquiry promptly.</p>
          <form onSubmit={sendEmail}>
            <div className="form-group">
              <input
                type="text"
                id="first-name"
                name="firstName"
                placeholder="First Name"
                value={formData.firstName}
                onChange={handleChange}
              />
              <input
                type="text"
                id="last-name"
                name="lastName"
                placeholder="Last Name"
                value={formData.lastName}
                onChange={handleChange}
              />
            </div>
            <div className="form-group">
              <input
                type="email"
                id="email"
                name="email"
                placeholder="Email Address"
                value={formData.email}
                onChange={handleChange}
              />
            </div>
            <div className="form-group">
              <textarea
                id="message"
                name="message"
                placeholder="Type Your Message..."
                value={formData.message}
                onChange={handleChange}
              ></textarea>
            </div>
            
              <button className="button19" type="submit" role="button">
                <span>Submit</span>
              </button>
            
          </form>
        </div>

        <MapComponent />
      </div>

      <Footer />
    </div>
  );
};

export default Contact;
